import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function RequireRole({ role }) {
    const { token, user } = useAuth();

    // 🔒 No token 
    if (!token) {
        return <Navigate to="/login" replace />;
    }

    // 🔐 Get roles 
    let rawRoles =
        user?.role ||
        user?.roles ||
        user?.["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];

    if (!rawRoles) {
        return <Navigate to="/login" replace />;
    }

    // 🔥 Reduce to an array 
    const userRoles = Array.isArray(rawRoles)
        ? rawRoles.map(r => r.toLowerCase())
        : [rawRoles.toLowerCase()];

    const allowedRoles = Array.isArray(role)
        ? role.map(r => r.toLowerCase())
        : [role.toLowerCase()];

    // 🚫 Access check 
    const hasAccess = userRoles.some(r => allowedRoles.includes(r));

    if (!hasAccess) {
        return <Navigate to="/dashboard" replace />;
    }

    return <Outlet />;
}